export default __webpack_public_path__ + "static/media/blood-bank.27a5c795.png";